import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LogoZh } from  "../../assets/images/logo/img-logo-white_horizontal_zh.svg";
import { ReactComponent as LogoDefult } from "../../assets/images/logo/img-logo-white_horizontal.svg";

const LocalizedLogo = ({ className, ...props }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  
  // 設定語系標識到 body 元素
  React.useEffect(() => {
    document.body.setAttribute('data-language', currentLanguage);
  }, [currentLanguage]);

  // 根據語系選擇對應的 logo
  const getLogoByLanguage = () => {

    switch (currentLanguage) {
      case 'zh-TW':
        return <LogoZh className={className}{...props} />;
      default:
        return <LogoDefult className={className}{...props} />;
    }
  };

  return getLogoByLanguage();
};

export default LocalizedLogo;
